import { atom } from 'jotai';

export const selectedPracticeGroupAtom = atom<string | undefined>(undefined);
export const isOnUpdatePageAtom = atom<boolean>(false);
